









import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { BehaviorEnum } from "@/services/posts/types";
@Component
export default class VideoSubRenderComponent extends Vue {
    // Props
    @Prop() properties!: fixedHtmlData;
    @Prop() videoActive!: number;

    // Watch
    @Watch("videoActive", { immediate: false, deep: true }) // On video post active, restart the video from start.
    onActiveChange(value: number) {
        if (this.isVideoLoaded) {
            if (value !== 0) { // When value is not 0, then the video is active. Value refers to the post total active count.
                this.video.currentTime = 0;
                this.video.play();
            } else {
                this.video.pause();
            }
        }
    }

    @Watch("properties", { immediate: true, deep: true })
    onPropertiesDataChanged(value: any) {
        this.setDisplayVideoStyles();
    }

    // -Data Properties-
    video = {} as HTMLVideoElement;
    videoStyle = "";
    isVideoLoaded = false;

    // Computed
    get src() {
        return this.properties.src;
    }

    get videoSrc(): string {
        const roundedHeight = Math.round(this.properties.position.channelHeight);
        const roundedWidth = Math.round(this.properties.position.channelWidth);
        return `${this.src}/${roundedHeight}/${roundedWidth}`;
    }

    // lifecycle hooks
    mounted() {
        this.video = this.$refs.video as HTMLVideoElement;
        this.video.autoplay = true;
        this.loadVideo();
    }

    // Methods
    loadVideo() {
        this.video.onloadeddata = () => {
            this.isVideoLoaded = true;
        };
        this.video.src = this.videoSrc;
        this.video.muted = true;
        this.video.play();
    }

    setDisplayVideoStyles() {
        this.videoStyle = "";
        const ratio = Math.max(this.properties.position.channelWidth / this.properties.position.videoWidth, this.properties.position.channelHeight / this.properties.position.videoHeight);
        if (this.properties.behavior === BehaviorEnum.crop) {
            if (ratio < 1) this.videoStyle = `transform: scale(${ratio}) translate(-50%, -50%)`;
        }

        if (this.properties.behavior === BehaviorEnum.letterBox) {
            if (this.properties.position.videoWidth > this.properties.position.channelWidth || this.properties.position.videoHeight > this.properties.position.channelHeight) {
                const ratio = Math.min(this.properties.position.channelWidth / this.properties.position.videoWidth, this.properties.position.channelHeight / this.properties.position.videoHeight);
                this.videoStyle = `
                    width: ${this.properties.position.videoWidth * ratio}px;
                    height: ${this.properties.position.videoHeight * ratio}px;
                `;
            }
        }
    }
}
